import pkg from '../package.json';

export const appVersion =
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? pkg.version ?? '0.0.0';
